// extracted by mini-css-extract-plugin
export default {"bottom_nav_main":"bottomNav_bottom_nav_main__eqy2E","icons_fixed":"bottomNav_icons_fixed__ED5p1","cart":"bottomNav_cart__WWRaL","bubble":"bottomNav_bubble__9KbYe"};